'use client';

import React, { useState } from 'react';
import dynamic from 'next/dynamic';

const ShiftCoverageChart = dynamic(() => import('./ShiftCoverageChart'), { ssr: false });
const WeeklyHoursChart = dynamic(() => import('./WeeklyHoursChart'), { ssr: false });

const periods = ['Today', 'This Week', 'This Month'];

export default function DashboardCharts() {
  const [activePeriod, setActivePeriod] = useState('Today');

  return (
    <div className="grid grid-cols-1 xl:grid-cols-5 2xl:grid-cols-5 gap-4 sm:gap-5">
      {/* Shift Coverage — full width on mobile, wider on xl */}
      <div className="xl:col-span-3 2xl:col-span-3 card-elevated p-4 sm:p-5">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="text-[15px] font-600 text-foreground">Shift Coverage Timeline</h3>
            <p className="text-xs text-muted-foreground mt-0.5">Staff on shift by hour across all facilities</p>
          </div>
          <div className="flex items-center gap-1 bg-muted rounded-lg p-1">
            {periods?.map((p) => (
              <button
                key={`period-${p}`}
                onClick={() => setActivePeriod(p)}
                className={`px-2 sm:px-3 py-1 text-xs font-500 rounded-md transition-colors ${
                  activePeriod === p ? 'bg-card shadow-sm text-foreground' : 'text-muted-foreground hover:text-foreground'
                }`}
              >
                {p}
              </button>
            ))}
          </div>
        </div>
        <div className="h-[180px] sm:h-auto">
          <ShiftCoverageChart />
        </div>
      </div>
      {/* Weekly Hours — hidden on mobile, visible sm+ */}
      <div className="hidden sm:block xl:col-span-2 2xl:col-span-2 card-elevated p-4 sm:p-5">
        <div className="mb-4">
          <h3 className="text-[15px] font-600 text-foreground">Hours by Specialty</h3>
          <p className="text-xs text-muted-foreground mt-0.5">This week — regular vs overtime</p>
        </div>
        <WeeklyHoursChart />
        {/* Legend */}
        <div className="flex items-center gap-4 mt-3">
          {[
            { label: 'Regular', color: 'bg-primary' },
            { label: 'Overtime', color: 'bg-warning' },
          ]?.map((item) => (
            <div key={`legend-${item?.label}`} className="flex items-center gap-1.5">
              <span className={`w-2.5 h-2.5 rounded-sm ${item?.color}`} />
              <span className="text-[11px] text-muted-foreground">{item?.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}